import React, { useEffect } from 'react';
import { push } from 'connected-react-router';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { Parser } from 'html-to-react';
import draftToHtml from 'draftjs-to-html';
import { getCommuteDestination } from '../Utils/localStorageUtil';
import FeedbackModal from './FeedbackModal';
import MapViewComponent from './MapViewComponent';
import TopMenu from './TopMenu';
import Navbar from './Navbar/Navbar';
import ExploreButton from './ExploreButton';
import CallToActionButton from './CallToActionButton';
import CommutePinModal from './CommutePinModal';
import { capitalize, changeTheme, imageUrlUtil, setPageTitle } from '../Utils/otherUtils';
import { openNavbar } from '../Actions/ToggleActions';

const StartPageComponent = () => {
  const dispatch = useDispatch();
  const {
    language,
    text: { municipalityPage },
  } = useSelector(state => state.Language);
  const toggle = useSelector(state => state.ToggleReducer);
  const { feedbackModalIsOpen } = useSelector(state => state.ToggleReducer);
  const theme = useSelector(state => state.MunicipalityReducer.theme);
  const languages = useSelector(state => state.MunicipalityReducer.languages);
  const municipality = useSelector(state => state.MunicipalityReducer);
  const mapView = useSelector(state => state.MapViewReducer);

  useEffect(() => {
    if (!toggle.startDropdownIsOpen) {
      dispatch(openNavbar());
    }
  }, []);

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  useEffect(() => {
    setPageTitle('Välkommen hit');
  }, []);

  useEffect(() => {
    setPageTitle(`Välkommen hit - ${capitalize(municipality.name)}`);
  }, [municipality.name]);

  useEffect(() => {
    if (languages && !languages.includes(language.toUpperCase())) {
      dispatch(push(`/sv/${municipality.name}`));
    }
  }, [languages]);

  const htmlToReactParser = new Parser();
  const mapViewComponent = mapView.center ? <MapViewComponent /> : null;

  return municipality.name ? (
    <div>
      <div className="start-view-wrapper" />
      <div className={classNames('start-view-container', { hidden: !toggle.startDropdownIsOpen })}>
        <div className="bg-image-container" style={{ backgroundImage: `url(${imageUrlUtil(municipality.backgroundImage).cover})` }}>
          <div className="bg-overlay" />
        </div>
        <div className={classNames('wrapper', { hidden: !toggle.startDropdownIsOpen })}>
          <div className="row collapse">
            <div className="columns small-6 medium-3 logo-container">
              <img src={imageUrlUtil(municipality.logoImage).original} alt={`${municipality.name} logo`} />
            </div>
            <div className="columns small-6 medium-9">
              <TopMenu />
            </div>
          </div>
          <div className="row collapse text-wrapper">
            <div className="ta-center">
              <h1>{municipalityPage.moveTo + capitalize(municipality.name)}</h1>
            </div>
            <div className="ta-center preamble">
              {
                municipality.preamble ?
                htmlToReactParser.parse(draftToHtml(municipality.preamble[language].content)) :
                null
              }
            </div>
          </div>
        </div>
        <ExploreButton />
        {municipality.callToActionButton.active ? <CallToActionButton /> : null}
      </div>
      {
        !toggle.startDropdownIsOpen &&
        toggle.commuteModalIsOpen &&
        !getCommuteDestination() &&
        <CommutePinModal />
      }
      { feedbackModalIsOpen ? <FeedbackModal email="andreas.bygdeson@knightec.se" /> : null }
      {mapViewComponent}
      <Navbar />
    </div>
  ) : null;
};

export default StartPageComponent;



// WEBPACK FOOTER //
// ./src/Components/StartPageComponent.js